import React, { Suspense, lazy } from 'react'
import { Route, Switch } from 'react-router-dom'

const Front = lazy(() => import('layout/Front/ContentWrapper'))
const Portal = lazy(() => import('layout/Portal/ContentWrapper'))

const App: React.FC = () => {
	return (
		<>
			<Suspense fallback={<div />}>
				<Switch>
					<Route path='/admin/' component={Portal} />
					<Route path='/portal/' component={Portal} />
					<Route path='/reports/' component={Portal} />
					<Route path='/' component={Front} />
				</Switch>
			</Suspense>
		</>
	)
}

export default App
